import React from "react";
import { Box, Button, Grid, Link, Paper, TextField, Typography } from "@mui/material";

export default function CustomerComment() {
  return (
    <>
      <Box
        component={"container"}
        sx={{
          // alignItems: "center",
          // justifyItems: "center",
          marginTop: "96px",
          display: "flex",
          flexDirection: { lg: "row", md: "row", sm: "column", xs: "column" },
          width:'100%',
          justifyContent:{xl:'space-around',lg:'space-between'}
        }}
      >
        <Box>
          <Box>
            <Typography
              sx={{
                fontSize: {lg: "40px", md: "40px", sm: "30px", xs: "25px"},
                fontWeight: "600",
                // lineHeight: "56px",
                lineHeight: {lg: "56px", md: "56px", sm: "56px", xs: "40px"},
                // paddingRight: "88px",
                // width: "100%"
                pl:{xl:'20px',lg:'0px'},
                maxWidth: "464.69px"
                
              }}
            >
              What customer say about Eatcoast ?
            </Typography>
          </Box>
        </Box>

        <Box sx={{mr:{xl:'25px',lg:'0px'}}}>
          <Box
            sx={{
              
              background: "#FFFFFF",
              borderRadius: "8px",
              border: "2px solid #F6F6F6",
              // maxWidth: "746px",
              paddingRight: {lg: "0px", md: "0px", sm: "20px", xs: "30px"},
              width: {lg: '746px', md: 'auto', sm: 'auto', xs: 'auto'},
              paddingBottom: "16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",

                // paddingRight: {lg: "32px", md: "32px", sm: "32px", xs :"5px"}
              }}
            >

              <Box sx={{ display: "flex", flexDirection: "row",alignItems:'center' }}>

                <Box
                  sx={{
                    marginTop: "39.84px",
                    paddingLeft: "16px",
                  }}
                >
                  <img
                    src="./images/iMacMemoji.svg"
                    alt=""
                    width="56px"
                    height="56px"
                  />
                </Box>
                
                {/* <Box sx={{ display: "flex", flexDirection: "row",alignItems:'center', justifyContent: 'space-between' }}> */}

                <Box>
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: {lg: "24px", md: "24px", sm: "20px", xs: "18px"},
                      // lineHeight: "36px",
                      letterSpacing: "0.01em",
                      color: "#1A1824",
                      paddingLeft: "16px",
                      marginTop: "39.84px",

                      // marginTop: "7.59px"
                    }}
                  >
                    Mendy Berliana
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      fontSize: {lg: "16px", md: "16px", sm: "14px", xs: "12px"},
                      // lineHeight: "36px",
                      letterSpacing: "0.01em",
                      color: "#9EA3AE",
                      paddingLeft: "16px",
                    }}
                  >
                    Senior Director
                  </Typography>
                </Box>

              </Box>

                <Box
                sx={{
                  marginTop: "23.84px",                  
                  display: "flex",
                  flexDirection: "row",
                  // justifyContent:'flex-end'
                }}
              >
                <Box 
                sx={{ paddingRight: {lg: "20px", md: "20px", sm: "20px", xs :"5px"} }}
                >
                  {" "}
                  <Link component="button">
                  <img
                    src="./images/lefticonbutton.svg"
                    alt=""
                    width="40px"
                    height="40px"
                  />
                  </Link>
                </Box>

                <Box 
                sx={{ paddingRight: {lg: "20px", md: "20px", sm: "20px", xs :"0px"} }}
                >
                  <Link component="button">
                  <img
                    src="./images/righticonbutton.svg"
                    alt=""
                    width="40px"
                    height="40px"
                    
                  />
                  </Link>
                </Box>


                </Box>

                {/* </Box> */}


              

              
            </Box>
            
            
            <Box>
              <Typography
                sx={{
                  marginTop: "8px",
                  fontWeight: "400",
                  fontSize: {lg: "18px", md: "18px", sm: "16px", xs: "14px"},
                  lineHeight: "145%",
                  letterSpacing: "0.015em",
                  color: "#545359",
                  width: {lg: '539.3px', md: '539.3px', sm: "100%", xs: '100%'},
                  paddingLeft: "16px",
                  paddingTop: "32px",
                }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
              </Typography>
            </Box>



              
            </Box>

          </Box>
        </Box>
      
    </>
  );
}
